import { required } from "vuelidate/lib/validators";

export default class ConfiguracaoData {
  ambiente = "";
  id = null;
  modelo = null;
  serie = "";
  idTokenCSC = "";
  tokenCSC = "";
  proximaNota = "";
  proximaVenda = "";
  ativo = true;
  informacoesComplementares = "";
  tipo_transportador = null;
  rntrc = null;
  solicitarDadosCartao = false;
  contigenciaSVCAN= false;
  padrao_pdv_web = false;
  constructor({
    ambiente = "",
    id = null,
    modelo = null,
    serie = "",
    idTokenCSC = "",
    tokenCSC = "",
    proximaNota = "",
    proximaVenda = "",
    ativo = true,
    informacoesComplementares,
    tipo_transportador = null,
    rntrc = null,
    solicitarDadosCartao = false,
    contigenciaSVCAN = false,
    padrao_pdv_web = false,
  }) {
    this.ambiente = ambiente;
    this.id = id;
    this.modelo = modelo;
    this.serie = serie;
    this.idTokenCSC = idTokenCSC;
    this.tokenCSC = tokenCSC;
    this.proximaNota = proximaNota;
    this.proximaVenda = proximaVenda;
    this.ativo = ativo;
    this.informacoesComplementares = informacoesComplementares;
    this.tipo_transportador = tipo_transportador;
    this.rntrc = rntrc;
    this.solicitarDadosCartao = solicitarDadosCartao;
    this.contigenciaSVCAN = contigenciaSVCAN;
    this.padrao_pdv_web = padrao_pdv_web;
  }
}

export const ConfiguracaoDataRequired = {
  ambiente: {
    required,
  },
  serie: {
    required,
  },
  proximaNota: {
    required,
  },
};
